import Dialog from 'quasar/src/plugins/Dialog.js';
import FunctionalRoleDetail from 'components/Dialogs/FunctionalRoleDetail.vue'

export default {
  namespaced: true,

  getters: {
    getFRoleChar: (_, __, ___, rootGetters) => id =>
      rootGetters['apis/findIndex']({ id, key: 'functionalRoles' }) === -1 ? '' : rootGetters['apis/getObjLabel'](id, 'functionalRoles')[0],
  },
  actions: {
    showFunctionalRole({ rootGetters }, { Fk_RuoliGestiti: id, Fk_ControparteRuolo: counterpartId, DataCreazione: createdAt, label }) {
      const { icon, DescrizioneRuolo } = rootGetters['apis/getObj']({ id, key: 'functionalRoles' })
      const getObjLabel = rootGetters['apis/getObjLabel']

      Dialog.create({
        component: FunctionalRoleDetail,
        icon,
        DescrizioneRuolo,
        counterpartId,
        label,
        getObjLabel,
        createdAt,
      })
    },
  },
}
